module.exports = __webpack_public_path__ + "static/media/12.4c45c1a5.jpg";